<template>
<div class="info-wrapper">
  <transition name="fade" mode="out-in">
    <div key="title" v-if="!active" class="title">
      <img src="../assets/images/logo.png" />
      <h1>&nbsp;</h1>
    </div>
    <h1 key="pending" v-else-if="pending">
      <font-awesome-icon class="beer" v-for="i in 13" :key="i" icon="beer"/>
    </h1>
    <h1 key="prize" class="last" v-else v-text="msg" />
  </transition>
</div>
</template>

<script>

import airhornSFX from '../assets/sounds/airhorn.mp3'
import beer from '../assets/sounds/beer.mp3'
import goodBeer from '../assets/sounds/goodBeer.mp3'

import { AwardType } from '../constants'

import { Howl } from 'howler'

export default {
  name: 'info',
  components: {
  },
  props: {
    active: Boolean,
    type: String
  },
  data () {
    return {
      pending: false,
      playedSound: true,

      airhornSFX: new Howl({
        src: airhornSFX
      }),
      beer: new Howl({
        src: beer
      }),
      goodBeer: new Howl({
        src: goodBeer
      })
    }
  },
  computed: {
    msg () {
      switch (this.type) {
        case AwardType.GOOD_BEER:
          return 'You won a good beer!'
        case AwardType.BETTER_BEER:
          return 'You won a better beer!'
        case AwardType.DOUBLE_BEER:
          return 'You won two beers!'
        case AwardType.ICE:
          return 'Take a knee!'
        default:
          return 'Machine Broke, Find The Barchair.'
      }
    }
  },
  watch: {
    active (val) {
      if (val) {
        this.pending = true
        setTimeout(() => {
          this.pending = false
          this.playSound()
        }, 2500)
      }
    }
  },
  methods: {
    playSound () {
      switch (this.type) {
        case AwardType.GOOD_BEER:
          this.beer.play()
          break
        case AwardType.BETTER_BEER:
          this.goodBeer.play()
          break
        case AwardType.DOUBLE_BEER:
          this.airhornSFX.play()
          break
        case AwardType.ICE:
          this.airhornSFX.play()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

h1 {
  font-size: 3em;
  width: 100%;
  margin: 32px 0;
  font-family: Baloo, Helvetica, sans-serif;
}

.title {
  position: relative;

  img {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.beer {
  animation: wave 1s ease-in-out infinite alternate;
  color: #6C2476;

  @for $i from 1 through 15 {
    &:nth-child(#{$i}) {
      animation-delay: calc(#{-($i - 1)} * .07s);
    }
  }

  &:nth-child(even) {
    color: #eebb00;
  }

  + .beer {
    margin-left: 5px;
  }
}

@keyframes wave {
  50% { transform: translateY(-100%); }
}
</style>
